import Client from './client';

export default class OrganizationAccounts extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  putInternalAndAccountsByOrganizationAndCurrency(organization, currency, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/accounts/${currency}`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteInternalAndAccountsByOrganizationAndCurrency(organization, currency, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/accounts/${currency}`, {
      ...options,
       method: 'DELETE',
    });
  }

  postInternalAndAccountsAndTransactionsAndManualByOrganizationAndCurrency(organization, currency, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/accounts/${currency}/transactions/manual`, {
      ...options,
       method: 'POST',
    });
  }

  deleteInternalAndAccountsAndTransactionsAndManualByOrganizationAndCurrencyAndId(organization, currency, id, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/accounts/${currency}/transactions/manual/${id}`, {
      ...options,
       method: 'DELETE',
    });
  }

  getAccountsByOrganization(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/accounts`, options);
  }

  getAccountsByOrganizationAndCurrency(organization, currency, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/accounts/${currency}`, options);
  }

  getAccountsAndContactsByOrganizationAndCurrency(organization, currency, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/accounts/${currency}/contacts`, options);
  }

  postAccountsAndContactsByOrganizationAndCurrency(organization, currency, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/accounts/${currency}/contacts`, {
      ...options,
       method: 'POST',
    });
  }

  getAccountsAndContactsByOrganizationAndCurrencyAndId(organization, currency, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/accounts/${currency}/contacts/${id}`, options);
  }

  deleteAccountsAndContactsByOrganizationAndCurrencyAndId(organization, currency, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/accounts/${currency}/contacts/${id}`, {
      ...options,
       method: 'DELETE',
    });
  }

  getAccountsAndStatisticsByOrganizationAndCurrency(organization, currency, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/accounts/${currency}/statistics`, options);
  }

  getAccountsAndTransactionsByOrganizationAndCurrency(organization, currency, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/accounts/${currency}/transactions`, options);
  }

}
